import React from "react";
import KYCVerification from "./components/KYCVerification";
import Web3Provider from "./providers/Web3Provider";
import "./App.css";

function App() {
  return (
    <Web3Provider>
      <KYCVerification />
    </Web3Provider>
  );
}
export default App;
